export let calendarDayOfWeek_Tuesday = "$Z1RVb";
export default {calendarDayOfWeek_Tuesday};